import React from "react";

import * as Styled from "./styles";

export type RadioProps = {
  label: string;
  name: string;
  selected?: boolean;
  onChange: (selected: boolean) => void;
};

export const Radio: React.FC<RadioProps> = ({
  label,
  name,
  selected = false,
  onChange,
}) => {
  return (
    <Styled.RadioWrapper>
      <Styled.HiddenRadio
        type="radio"
        name={name}
        checked={selected}
        onChange={() => onChange(!selected)}
      />
      <Styled.RadioIndicator selected={selected} />
      <Styled.LabelText>{label}</Styled.LabelText>
    </Styled.RadioWrapper>
  );
};

export type RadioGroupProps = {
  name: string;
  options: RadioOption[];
  onChange: (value: string) => void;
  selectedValue?: string;
};

export type RadioOption = {
  label: string;
  value: string;
};

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  options,
  onChange,
  selectedValue,
}) => {
  return (
    <>
      {options.map((option) => (
        <Radio
          key={option.value}
          label={option.label}
          name={name}
          selected={selectedValue === option.value}
          onChange={() => onChange(option.value)}
        />
      ))}
    </>
  );
};

export default RadioGroup;
